import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useGetGroupQuery, useGetGroupSubscribersQuery } from '../../api/groupApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import Badge from '../../components/Badge/Badge';
import s from '../../styles/shared/page.module.css';
import buttons from '../../styles/shared/buttons.module.css';
import table from '../../styles/shared/table.module.css';

const STATUS_COLORS = {
  active: { background: 'var(--color-badge-info-bg)', color: 'var(--color-success)' },
  pending: { background: 'var(--color-badge-warn-bg)', color: 'var(--color-badge-warn-text)' },
  unsubscribed: { background: 'var(--color-badge-neutral-bg)', color: 'var(--color-text-muted)' },
};

export default function GroupSubscribersPage() {
  const { id: groupId } = useParams();
  const navigate = useNavigate();
  const showToast = useToast();

  const { data: group } = useGetGroupQuery(groupId);
  const {
    data: rows,
    isLoading,
    isError,
    error,
  } = useGetGroupSubscribersQuery(groupId);

  useEffect(() => {
    if (isError) showToast('error', 'Subscribers', errMsg(error, 'Could not load subscribers.'));
  }, [isError, error, showToast]);

  return (
    <div className={s.page}>
      <div className={s.header}>
        <div>
          <h1>Subscribers{group ? ` — ${group.name}` : ''}</h1>
          <p className={`${s.subtitle} textMuted`}>People subscribed to this group.</p>
        </div>
        <Button
          label="Add subscriber"
          icon="pi pi-plus"
          className={buttons.btnPrimary}
          onClick={() => navigate(`/admin/groups/${groupId}/subscribers/create`)}
        />
      </div>

      <div className={table.tableWrapper}>
        <DataTable
          value={rows ?? []}
          loading={isLoading}
          emptyMessage="No subscribers yet. Add one above."
          responsiveLayout="stack"
        >
          <Column
            header="Email"
            className={table.contactCol}
            body={(row) => <div className={table.cellInsider}>{row.subscriber.email}</div>}
          />
          <Column
            header="Channel"
            className={`${s.mutedCell} ${table.contactCol}`}
            body={(row) => <div className={table.cellInsider}>{row.subscription.channel ?? '—'}</div>}
          />
          <Column
            header="Status"
            className={table.statusCol}
            body={(row) => (
              <div className={table.cellInsider}>
                <Badge {...(STATUS_COLORS[row.subscription.status] ?? STATUS_COLORS.pending)}>
                  {row.subscription.status}
                </Badge>
              </div>
            )}
          />
        </DataTable>
      </div>
    </div>
  );
}
